import {AxisBottom, AxisLeft} from '@visx/axis';

import {scToTwColour} from '../../../theme';
import {
  AXIS_BOTTOM_OFFSET,
  AXIS_LEFT_OFFSET,
  AXIS_TOP_OFFSET,
} from '../utils/constants';
import {truncate} from '../utils/functions';

import type {ScaleBand, ScaleLinear} from 'd3-scale';

type Props = {
  height: number;
  xScale: ScaleBand<string>;
  yScale: ScaleLinear<number, number>;
};
export function ChartAxis({height, xScale, yScale}: Props): React.JSX.Element {
  return (
    <>
      <AxisBottom
        top={height - AXIS_BOTTOM_OFFSET}
        left={AXIS_LEFT_OFFSET}
        scale={xScale}
        stroke={scToTwColour('theme.colours.slate6')}
        tickStroke={scToTwColour('theme.colours.slate7')}
        tickComponent={({formattedValue, ...props}) => (
          <text {...props} y="14">
            {formattedValue
              ? truncate(formattedValue, xScale.bandwidth() / 6)
              : '-'}
          </text>
        )}
        tickLabelProps={() => ({
          textAnchor: 'middle',
          fill: scToTwColour('theme.colours.slate12'),
          fontSize: 12,
        })}
        hideTicks
      />

      <AxisLeft
        top={AXIS_TOP_OFFSET}
        left={AXIS_LEFT_OFFSET}
        scale={yScale.nice()}
        numTicks={10}
        stroke={scToTwColour('theme.colours.slate6')}
        tickStroke={scToTwColour('theme.colours.slate7')}
        tickValues={yScale.ticks().filter(Number.isInteger)}
        tickLabelProps={(tick) => ({
          textAnchor: 'end',
          fill: scToTwColour('theme.colours.slate12'),
          fontSize: 12,
          lineHeight: 12,
          x: -12, // magic number for rendering
          y: yScale(tick) + 5, // magic number for rendering
        })}
        hideZero
      />
    </>
  );
}

ChartAxis.displayName = 'ChartAxis';
